const isProd = process.env.NODE_ENV === "production";

const logTag = 'corrector pc>>>';
export function logToConsole(...data: any) {
    if (!isProd) console.log(logTag, ...data);
}

export function logError(...errors: any) {
    if (!isProd) console.error(logTag, ...errors)
}

export function logToServer(...errors: any) {
    if (!isProd) console.error(logTag, ...errors);
    //TODO 实现报错上传服务器
}